<template>
  <!-- Where do we use this ? -->
  <div class="landing_content justify--center pb-5 auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center">
      <router-link class="findex_logo" to="/">
        <img src="@/components/assets/findex_logo_white_dash.png" height="100" />
      </router-link>
    </div>
    <div class="justify--center pb-5 align-content--center">
      <div class="btn-group ">
        <va-button v-if="authenticated" class="btn alignLeft" @click="onPortalClick">PORTAL</va-button>
        <va-button v-else class="btn alignRight mt-4" v-on:click="submit">SIGN IN</va-button>
      </div>
    </div>
  </div>
</template>

<!-- Composition API -->
<script setup>
// import { useMsal } from '@/composition-api/useMsal';
import { msalConfig, msalInstance, apiConfig, loginRequest, graphConfig } from "@/shared/services/auth-config";
import { NavigationClient } from "@azure/msal-browser";
import { useRouter } from 'vue-router'
import { useStore } from "vuex";

// const { instance } = useMsal();
const store = useStore();
const router = useRouter()

const loginPopup = async () => {
  console.log('Disabled!');
  // const result = await instance.loginPopup(loginRequest);
  // if (result) {
  //   console.log(result)
  //   if (result.accessToken) {
  //     store.commit('setAccessToken', result.accessToken);
  //     // store.commit('toggleAuthenticated', true);
  //     store.commit('user/setUserAuthData', result); // reading the user-data.ts state store
  //     store.commit('setUserDataToSession', result); //readin the normal store.
  //     store.dispatch('user/retrieveUserDetail')
  //     router.push({ name: 'dashboard' })
  //   }
  // }
}

const submit = async () => {
  await msalInstance.initialize();
  const navigationClient = new NavigationClient()
  msalInstance.setNavigationClient(navigationClient)
  try {
    const result = await msalInstance.loginPopup(loginRequest);
    store.commit('setAccessToken', result.accessToken);
    store.commit('user/setUserAuthData', result);
    store.commit('setUserDataToSession', result);
    store.dispatch('user/retrieveUserDetail');
    router.push({ name: 'dashboard'});
  } catch (error) {
    console.error(`Login failed: ${error}`);
  }

}

</script>

<style lang="scss" scoped>
.landing_content {
  background: #000;
  height: 100vh;
  // display: flex;
  padding: 100px;
  text-align: center;

}

.findex_logo {
  text-align: center;
  padding: 10px;
}

.auth-layout {
  min-height: 100vh;
  background: #1B1F22;

  &__card {
    width: 100%;
    max-width: 600px;
  }
}
</style>